import routes from '../../../routes/routes.json';


/* get classname */
const getClassName = (
    tabName: 'home' | 'wholesaler' | 'manage-users' | 'manage-roles' | 'manage-categories' | 'logs',
    currentPathName: string,
    type: 'Nav' | 'Menu',
) => {
    const className = type === 'Nav' ? 'button-container button-outline text-decoration-none' : 'button-container button-menu-item text-decoration-none button-menu-not-selected';
    const inactiveClassName = type === 'Nav' ? 'button-not-selected' : '';
    switch (tabName) {
      case 'home':
        return (`${className} ${currentPathName === '/' ? '' : inactiveClassName}`);
      case 'wholesaler':
        return ('text-decoration-none');
      case 'manage-users':
        return (`${className} ${currentPathName.includes(
            routes['manage-users']) ? '' : inactiveClassName}`);
      case 'manage-roles':
        return (`${className} ${currentPathName.includes(
            routes['manage-roles']) ? '' : inactiveClassName}`);
      case 'manage-categories':
        return (`${className} ${currentPathName.includes(
            routes['manage-categories']) ? '' : inactiveClassName}`);
      default:
        return (`${className} ${currentPathName.includes(
            routes['landing']) ? '' : inactiveClassName}`);
    }
};

/* get topbar nav items */
function getTopBarNavItems(currentPathName: string) {
    const topBarNavItems: {
        url: string,
        label: string,
        className: string,
        order: number,
        separator?: boolean,
    }[] = [
        {
          url: routes['wholesaler'],
          label: 'Wholesaler',
          className: getClassName('wholesaler', currentPathName , 'Nav'),
          order: 2,
        },
      ];
    
    topBarNavItems.sort((a, b) => a.order - b.order);
    return topBarNavItems;
}

/* get topbar nav setting items */
function getTopBarSettingItems(currentPathName: string) {
  const topBarNavSettingItems: {
      url: string,
      label: string,
      className: string,
      order: number,
      isAdmin: boolean,
      type: 'navLink' | 'button',
  }[] = [
      {
        url: routes['manage-users'],
        label: 'Manage Users',
        className: getClassName('manage-users', currentPathName, 'Menu'),
        order:  1,
        type: 'navLink',
        isAdmin: true,
      },
      {
        url: routes['manage-roles'],
        label: 'Manage Roles',
        className: getClassName('manage-roles', currentPathName, 'Menu'),
        order: 2,
        type: 'navLink',
        isAdmin: true,
      },
      {
        url: routes['manage-categories'],
        label: 'Manage Categories',
        className: getClassName('manage-categories', currentPathName, 'Menu'),
        order: 3,
        type: 'navLink',
        isAdmin: true,
      },
      {
        url: '',
        label: 'Logs',
        className: getClassName('logs', currentPathName, 'Menu'),
        order: 4,
        type: 'button',
        isAdmin: false,
      },
    ];
  
  topBarNavSettingItems.sort((a, b) => a.order - b.order);
  return topBarNavSettingItems;
}

export {getTopBarNavItems, getTopBarSettingItems};
